import React from "react";
import { View, StyleSheet } from "react-native";
import ColorPicker, {
  HueSlider,
  InputWidget,
  OpacitySlider,
  Panel1,
} from "reanimated-color-picker";

type ColorContentProps = {
  textColor: string;
  onSelect: (color: string) => void;
};

const ColorContent: React.FC<ColorContentProps> = ({ textColor, onSelect }) => {
  return (
    <View style={styles.colorPickerContainer}>
      <ColorPicker value={textColor} onComplete={(hex) => onSelect(hex.hex)}>
        <View style={styles.colorPickerContent}>
          <Panel1 style={styles.colorPanel} />
          <HueSlider />
          <OpacitySlider />
          <InputWidget />
        </View>
      </ColorPicker>
    </View>
  );
};

const styles = StyleSheet.create({
  colorPickerContainer: {
    backgroundColor: "#fff",
    padding: 8,
    width: "100%",
    maxWidth: 280,
    borderRadius: 6,
    marginHorizontal: "auto",
    // Shadow styles for Android and iOS
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 5, // Android shadow
  },
  colorPickerContent: {
    gap: 6,
  },
  colorPanel: {
    height: 90,
  },
});

export default ColorContent;
